import React, { useState } from 'react';
import '../assets/css/custom.css';

const socialLinks = [
  {
    name: 'Instagram',
    iconClass: 'fa-brands fa-instagram',
    url: 'https://www.instagram.com/erainterio9/',
    className: 'Instagram',
    label: 'Instagram',
  },
  {
    name: 'WhatsApp',
    iconClass: 'fa-brands fa-whatsapp',
    url: 'https://wa.me/918830219839', // Insert correct WhatsApp number here
    className: 'Whatsapp',
    label: 'WhatsApp',
  },
  {
    name: 'Facebook',
    iconClass: 'fa-brands fa-facebook-f',
    url: 'https://www.facebook.com/erainterior9/',
    className: 'Facebook',
    label: 'Facebook',
  },
  {
    name: 'Gmap',
    iconClass: 'fa-solid fa-map-location-dot',
    url: 'https://maps.app.goo.gl/rS5HGXeJqWJZgViu5', // Insert actual GMap URL
    className: 'Gmap',
    label: 'Gmap',
  },
];

function isMobile() {
  if (typeof window === 'undefined') return false;
  return window.innerWidth <= 600;
}

export default function SocialSidebar() {
  const [activeIdx, setActiveIdx] = useState(null);

  const handleShow = (idx) => {
    if (isMobile()) setActiveIdx(idx);
    else setActiveIdx(idx);
  };

  const handleHide = () => {
    setActiveIdx(null);
  };

  const handleClick = (idx, url) => {
    setActiveIdx(null); // auto-hide after click
    // Open in new tab as normal
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="era-socialsidebar">
      {socialLinks.map((link, idx) => (
        <button
          key={link.name}
          className={`sidebar-link ${link.className} ${activeIdx === idx ? 'active' : ''}`}
          aria-label={link.label}
          onMouseEnter={() => !isMobile() && handleShow(idx)}
          onMouseLeave={() => !isMobile() && handleHide()}
          onTouchStart={() => handleShow(idx)}
          onClick={e => {
            e.preventDefault();
            handleClick(idx, link.url);
          }}
          tabIndex={0}
        >
          <i className={link.iconClass}></i>
          <span className="sidebar-label">{link.name}</span>
        </button>
      ))}
    </div>
  );
}
